import Repository from "../../repository";

export default {
    Get: (payload) => Repository.post(`/api/MonthlyTickets/Get`, payload),
    GetById: (payload) => Repository.post(`/api/MonthlyTickets/GetById`, payload),
    GetActive: (payload) => Repository.post(`/api/MonthlyTickets/GetActive`, payload),
    Add: (payload) => Repository.post(`/api/MonthlyTickets/Add`, payload),
    Copy: (payload) => Repository.post(`/api/MonthlyTickets/Copy`, payload),
    Edit: (payload) => Repository.post(`/api/MonthlyTickets/Edit`, payload),
    Delete: (payload) => Repository.post(`/api/MonthlyTickets/Delete`, payload),
    ChangeStatus: (payload) => Repository.post(`/api/MonthlyTickets/ChangeStatus`, payload),
}